import React from 'react'
import IndexPage from '../index'

const IndexPageEn = () => {
    return <IndexPage languageCode="en" />
}

export default IndexPageEn
